import FundsService from '@/api/FundsService.js'
import Vue from 'vue'
export const fundsModule = {
  namespaced: true,
  state: () => ({
    fundsData: [],
    fundsLoadStatus: 'request',
    paginationFundsStateParams: {
      count: 0,
      limit: 5,
      total: 0,
      page: 0
    }
  }),

  getters: {
    numPages: (state) =>
      Math.ceil(
        state.paginationFundsStateParams.total /
        state.paginationFundsStateParams.limit
      )
  },
  mutations: {
    get_all(state, data) {
      state.fundsData = [...data]
    },
    create(state, data) {
      state.fundsData.unshift(data[0])
    },

    edit_multiple(state, data) {
      let indexed = state.fundsData.findIndex(
        (x) => x.finreestr_funds__id == data.id
      )

      Object.assign(state.fundsData[indexed], data.dataEdit)
    },

    delete_data(state, id) {
      let indexed = state.fundsData.findIndex(
        (x) => x.finreestr_funds__id == id
      )
      state.fundsData.splice(indexed, 1)
    },

    update_pagination(state, { total, count, limit, page }) {
      state.paginationFundsStateParams = { total, count, limit, page }
    },

    load_request(state, status) {
      state.fundsLoadStatus = 'request'
    },
    load_success(state) {
      state.fundsLoadStatus = 'success'
    },
    load_error(state) {
      state.fundsLoadStatus = 'error'
    }
  },
  actions: {
    getFundsAll({ commit }, params) {
      commit('load_request')

      FundsService.getAll(params)
        .then((data) => {
          commit('update_pagination', data.data.data)
          commit('get_all', data.data.data.rows)
          commit('load_success')
        })
        .catch((error) => {
          Vue.$toast.error('Ошибка загрузки', { duration: 5000 })
          commit('load_error')
        })
    },

    createFundsData({ commit }, createData) {
      FundsService.create(createData)
        .then((data) => {
          commit('create', data.data.data.rows)
          Vue.$toast.success('Запись добавлена')
        })
        .catch((error) => {
          Vue.$toast.error('Ошибка загрузки', { duration: 5000 })
        })
    },

    editFundsMultiple({ commit }, { id, dataEdit }) {
      FundsService.editMultiple(id, dataEdit)
        .then((data) => {
          commit('edit_multiple', { id, dataEdit })
          Vue.$toast.success('Данные успешно обновлены')
        })
        .catch((error) => {
          Vue.$toast.error('Ошибка загрузки', { duration: 5000 })
        })
    },

    deleteFundsData({ commit }, id) {
      // commit("load_request");
      FundsService.delete(id)
        .then((data) => {
          commit('delete_data', id)
          Vue.$toast.success('Данные успешно удалены')
        })
        .catch((error) => {
          Vue.$toast.error('Ошибка загрузки', { duration: 5000 })
        })
    }
  }
}
